<mat-icon *ngIf="partnerSummary?.hasSimilarPartners" (click)="clicked()"
          class="m-r-4 link"
          color="warn"
          fontIcon="warning"
          matTooltip="Doublon possible"></mat-icon>
